import { render, staticRenderFns } from "./RealPropertyTax.vue?vue&type=template&id=36b7dee2&"
import script from "./RealPropertyTax.vue?vue&type=script&lang=js&"
export * from "./RealPropertyTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports